import {
  CreditApprovalRound,
  CreditApprovalRoundStatus,
  CreditApprovalStep,
  CreditApprovalStepDecision,
  CreditApprovalStepType
} from '@indigo-ag/schema';

export class CreditApprovalUtil {
  /**
   * Credit Approval Steps types ordered in sequence based on business rules.
   */
  static allStepTypes: Record<CreditApprovalStepType, number> = {
    [CreditApprovalStepType.CREDIT_ANALYST_APPROVAL]: 0,
    [CreditApprovalStepType.CREDIT_SUPERVISOR_APPROVAL]: 1,
    [CreditApprovalStepType.CREDIT_MANAGER_APPROVAL]: 2,
    [CreditApprovalStepType.COMMERCIAL_DIRECTOR_APPROVAL]: 3,
    [CreditApprovalStepType.FINANCE_DIRECTOR_APPROVAL]: 3
  };

  static getStepIndexByApprovalType(approvalType: CreditApprovalStepType): number {
    return CreditApprovalUtil.allStepTypes[approvalType];
  }

  static getApprovalTypeByStepIndex(stepIndex: number): CreditApprovalStepType | undefined {
    for (const [key, value] of Object.entries(CreditApprovalUtil.allStepTypes)) {
      if (value === stepIndex) {
        return key as CreditApprovalStepType;
      }
    }
    return undefined;
  }

  static sortSteps(steps: CreditApprovalStep[]): CreditApprovalStep[] {
    return [...steps].sort(
      (a, b) =>
        CreditApprovalUtil.getStepIndexByApprovalType(a.approvalType) -
        CreditApprovalUtil.getStepIndexByApprovalType(b.approvalType)
    );
  }

  static isPreviousStepApproved(steps: CreditApprovalStep[], approvalType: CreditApprovalStepType): boolean {
    const targetStepIdx = CreditApprovalUtil.getStepIndexByApprovalType(approvalType);

    if (targetStepIdx === 0) {
      return true;
    } else {
      const prevStepType = CreditApprovalUtil.getApprovalTypeByStepIndex(targetStepIdx - 1);
      const prevStep = steps.find(s => s.approvalType === prevStepType);

      return !!prevStep && prevStep.decision === CreditApprovalStepDecision.APPROVED;
    }
  }

  static getStepByApprovalType(
    steps: CreditApprovalStep[],
    approvalType: CreditApprovalStepType
  ): CreditApprovalStep | undefined {
    return steps.find(s => s.approvalType === approvalType);
  }

  static isRoundComplete(round?: CreditApprovalRound): boolean {
    return !!round && round.status === CreditApprovalRoundStatus.COMPLETE;
  }

  static isRoundStarted(round?: CreditApprovalRound): boolean {
    return !!round;
  }
}
